import { connect } from "react-redux";
var UIActions = require("lib/actions/UIActions");
var PaywallModal = require("components/users/teachers/PaywallModal");

require("data/truncated_data_note.scss");

@connect(
	(state, props) => ({}),
	(dispatch, props) => ({
		showHistoricalDataPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }))
	})
)

class TruncatedDataNote extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	render() {
		var total = this.props.total;
		var type = this.props.type;
		if (type == BOOKS) {
			var studentsTotalData = (
				<p>Your students have done activites for <b>{ total }</b> { this.props.type }.</p>
			)
		} else if (type == GOALS || type == RL_GRAPH) {
			var className = "truncatedDataNoteNoBorder"
		} else {
			var studentsTotalData = (
				<p>Your students have done <b>{ total }</b> { this.props.type }.</p>
			)
		}
		return (
			<div className={ "truncatedDataNote " + className }>
				<div className="truncatedInner">
					<p className="entireClassText">
						{ studentsTotalData }
						Want to see all of the data for your students?
						<a className="btn btn-link" onClick={this.props.showHistoricalDataPaywall}>
							Learn about WR Silver
						</a>
					</p>
				</div>
			</div>
		);
	}
}

var BOOKS = "books";
var GOALS = "goals";
var RL_GRAPH = "reading-level-graph"
TruncatedDataNote.propTypes = PageStrictPropTypes({
	total: PropTypes.number,
	type: PropTypes.string
});

module.exports = TruncatedDataNote;


// WEBPACK FOOTER //
// ./modules/components/data/TruncatedDataNote.js